
import contentComponents from '../../config/contentComponents';

export default {
  name: 'PcRenderContent',
  data() {
    return {
      className: 'app__render-content',
    };
  },
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  render(h) {
    const content = this.content || '<div></div>';

    const render = {
      components: {
        ...contentComponents,
      },
      // need to wrap in element so there's one child element
      // (causes slow down for vue compiler if not added)
      template: `
        <div
          class="${this.className}"
        >
          ${content}
        </div>
      `,
    };

    return h(render);
  },
};
